module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAALCAYAAABLcGxfAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACnSURBVHgBjZArDwIxEIS35DCQgECAAHHmDAKDQWD46Rg0AnMGgUKCoAJRviZ7yXLXe0yymXa2s4+KGIQQ1sRROjCq3Z/EFFMxyOCc+0IvosA0SxpIHIjcaA/lXcqQ6RhbTGPVKp6j7eG3ee8d4oTDSQYidljouTQdcjOeN+8/mSZvLHyPCh03VRLt2uiAeK5pK+WLJPD3rbr4Mo5HId9r0OpxlFJa8APXGza0xfRpKgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fj.png
// module id = ZBq1
// module chunks = 1